export const Right = ({children, customStyle, weeklyView}) => {
    return (
        <div className={`${!weeklyView && "p-2"} pb-0 right`} style={{width: "100%"}}>
            <div className={`border-right-container ${!weeklyView && "p-2"}`} style={customStyle}>
                {children}
            </div>
        </div>
    )
}